import { z } from "zod";

export const SendTestMessageChannelSchema = z.enum(["email", "linkedin"]);
export type SendTestMessageChannel = z.infer<typeof SendTestMessageChannelSchema>;

const BaseSendTestMessageRequestSchema = z.object({
	listPersonId: z.number(),
	message: z.string().min(1, { message: "Message is required" }),
	senderUserId: z.number(),
});

const EmailSendTestMessageRequestSchema = BaseSendTestMessageRequestSchema.extend({
	channel: z.literal("email"),
	subject: z.string().min(1, { message: "Subject is required" }),
	senderEmailId: z.number(),
	recipientEmail: z.string().email({ message: "Invalid email address" }),
	/** A composer test carries its Include signature; a campaign step's test leaves it to the setting. */
	includeSignature: z.boolean().optional(),
});

const LinkedinSendTestMessageRequestSchema = BaseSendTestMessageRequestSchema.extend({
	channel: z.literal("linkedin"),
	recipientLinkedinUrl: z
		.string()
		.url({ message: "Invalid URL" })
		.regex(/linkedin\.com\/in\//i, { message: "Must be a LinkedIn profile URL" }),
});

export const SendTestMessageRequestSchema = z.discriminatedUnion("channel", [
	EmailSendTestMessageRequestSchema,
	LinkedinSendTestMessageRequestSchema,
]);

export type SendTestMessageRequest = z.infer<typeof SendTestMessageRequestSchema>;
export type EmailSendTestMessageRequest = z.infer<typeof EmailSendTestMessageRequestSchema>;
export type LinkedinSendTestMessageRequest = z.infer<typeof LinkedinSendTestMessageRequestSchema>;

export const SendTestMessageResponseSchema = z.object({
	channel: SendTestMessageChannelSchema,
	renderedMessage: z.string(),
	renderedSubject: z.string().optional(),
	sentTo: z.string(),
	success: z.boolean(),
});

export type SendTestMessageResponse = z.infer<typeof SendTestMessageResponseSchema>;
